import { z } from "zod";

export const orderCreateSearchParamsSchema = z.object({
  marketplaceTypeCode: z.string().optional().catch(undefined),
  marketplaceGroupId: z.string().uuid().optional().catch(undefined),
  marketplaceProjectIds: z.array(z.string().uuid()).optional().catch(undefined),
  marketplaceProjectId: z.string().uuid().optional().catch(undefined),
  marketplaceTemplateId: z.string().uuid().optional().catch(undefined),
});

export type OrderCreateSearchParams = z.infer<
  typeof orderCreateSearchParamsSchema
>;
